import { setSessionStorageKey } from '@/scripts/sessionStorage'
import i18n from '@/i18n'

export default {
  namespaced: true,

  state: {
    locale: null
  },

  getters: {
    isRU: state => state.locale === 'ru'
  },

  mutations: {
    setLocale(state, payload) {
      setSessionStorageKey('locale', payload)
      i18n.locale = payload
      state.locale = payload
    }
  }
}
